module.exports = __webpack_public_path__ + "static/img/balance.ba42b66a.svg";